// import history from '@/utils/history';
import codeMessage from "./codeMessage";
import { toast } from "react-toastify";
import Dexie from 'dexie';

const errorHandler = (error, notify = true) => {
  const { response } = error;
  const db = new Dexie('DigiitPlatform');
  db.version(1).stores({
    auditlog: '++id, code, payload, message, response' // Primary key and indexed props
  });

  if (response && response.status) {
    //In v6, we get the error message (response?.data?.Error?.Message), while in v4, we get the message (response?.data)

    const message = response?.data?.Error?.Message ? response?.data?.Error?.Message : response?.data;
    const errorText = message ? message : codeMessage[response.status];

    const { status } = response;
    if (notify) {
      toast.error(errorText);
    }

    if (status == 404 || status == 401) {
      localStorage.clear();
      window.location.href = "/";
    } else {
      db.table('auditlog').add({ code: response?.status, message: `status code:${response?.status},${response.data}`, payload: response.config.data, response: response.data })
    }
    return response.data;

  } else {
    const message = response?.data && response?.data?.Error?.Message;

    const errorText = message || codeMessage[response?.status];
    const { status } = response;
    if (notify) {
      toast.error(errorText);
    }
    return {
      success: false,
      result: null,
      message: "Cannot connect to the server, Check your internet network",
    };

  }
};

export default errorHandler;
